import moment from "moment";

// DateFormat  Request
export const DataFormat = (data) => {
    if (data) {
        var date = moment(data).format("MM-DD-YYYY h:mm:ss A")
        return date;
    }
    return data;
}